import { BaseWidget } from './widget.model';

export type WeatherDays = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';
export enum TempUnit {
  C = 'C',
  F = 'F',
}
export type WeatherProvider = 'WEATHERNEWS' | 'ACCUWEATHER';

export enum UnitSystem {
  IMPERIAL = 'IMPERIAL',
  METRIC = 'METRIC',
}

export interface WeatherDailyForecast {
  date: string;
  minTemp: number;
  maxTemp: number;
  iconUrl: string;
  condition: string;
}

export interface WeatherHourlyForecast {
  temp: number;
  time: string;
}

export interface WeatherWidgetData {
  unit: string;
  id: string;
  dailyForecast: WeatherDailyForecast[];
  selectedDayHourly: WeatherHourlyForecast[];
}

export interface WeatherWidget extends BaseWidget {
  __typename: 'WeatherWidget';
  widgetData: WeatherWidgetData;
  settings: UserWeatherSettings
}

export interface WeatherQueryResponse {
  data: {
    forecast: WeatherWidgetData;
  };
}

export interface WeatherRequestInput {
  location_id: string | null;
  unit: TempUnit | null;
  // Not used anymore
  //   lat?: number | null;
  //   lon?: number | null;
  //  day?: WeatherDays | null;
  //   provider?: WeatherProvider | null;
}

export interface WeatherRequestArgs {
  input: WeatherRequestInput;
}

export interface UserWeatherSettings {
  day: WeatherDays;
  display_label: string;
  id: string;
  location_id: string;
  provider: WeatherProvider;
  unit: TempUnit;
  user_id: string;
}

export interface UserDataWeatherInput {
  day?: WeatherDays;
  display_label?: string;
  location_id?: string;
  provider?: WeatherProvider;
  unit?: TempUnit;
}

export interface SaveWeatherSettingsResponse {
  data: {
    userData: UserWeatherSettings;
  };
}

export interface GetWeatherSettingsResponse {
  data: {
    homepage: {
      dashboardId: string;
      widgets: Array<{
        settings?: UserWeatherSettings;
      }>;
    };
  };
}
